import CheckrBackgroundCheckView from "./CheckrBackgroundCheckView";

export default CheckrBackgroundCheckView;
